var _circle, _circle2, _circle3, _path, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIconWechat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 28729",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.54,
    height: 29.541,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 1.107,
    cy: 1.107,
    r: 1.107,
    transform: "translate(13.168 9.513)",
    fill: "#2dc100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(15.478 14.239)",
    fill: "#2dc100"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 1.107,
    cy: 1.107,
    r: 1.107,
    transform: "translate(8.457 9.513)",
    fill: "#2dc100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 292",
    d: "M14.77 0a14.77 14.77 0 1014.77 14.77A14.77 14.77 0 0014.77 0zM9.661 18.195l-2.556 1.152.533-2.036a5.7 5.7 0 01-2.875-4.777c0-3.3 3.227-5.973 7.208-5.973 3.338 0 6.145 1.88 6.965 4.432a8.375 8.375 0 00-.5-.016c-3.96 0-7.183 2.741-7.183 6.11a5.244 5.244 0 00.193 1.4 8.578 8.578 0 01-1.785-.292zm12.813 2.861l.464 1.921-2.11-1.071a7.371 7.371 0 01-2.434.407c-3.455 0-6.255-2.321-6.255-5.184s2.8-5.183 6.255-5.183 6.256 2.32 6.256 5.183a4.861 4.861 0 01-2.176 3.927z",
    fill: "#2dc100"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(19.543 14.239)",
    fill: "#2dc100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconWechat);
export default __webpack_public_path__ + "static/media/social-icon-wechat.0f00912fffb3d924f81e47b50050cd7b.svg";
export { ForwardRef as ReactComponent };